import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import '../src/assets/js/sb-admin-2.min.js'
import '../src/assets/css/sb-admin-2.min.css';
import VueTelInput from 'vue-tel-input'
import Storage from '@/helpers/storage.js'

import Axios from 'axios'

Vue.prototype.$http = Axios;
Vue.config.productionTip = false;
Vue.use(VueTelInput)

//creating variables
const token = Storage.get('token');
if(token){
	Axios.defaults.headers.common['Authorization'] = token
}
new Vue({	
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
